import Tabs from './Tabs.component';
export default Tabs;